<div class="nm-service" [ngClass]="{ active: serviceCard.id == 1 }">
  <div class="nm-service__icon fa {{ serviceCard.icon }} mb-3"></div>
  <p class="nm-primary fw-bolder text-uppercase mb-2">
    {{ serviceCard.title }}
  </p>
  <small class="nm-secondary">{{ serviceCard.description }}</small>
</div>
